import { PlatformStatisticsSchema, type PlatformStatistics } from '@/types/platformStatistics';
import { apiRequest } from './client';

const BASE = '/api/v1/platform-statistics';

export async function getPlatformStatistics(): Promise<PlatformStatistics> {
  const res = await apiRequest<unknown>({ url: BASE, method: 'GET' });
  return PlatformStatisticsSchema.parse(res);
}
